/**
 * Created by michal.stys on 26.10.2016.
 */

import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;